import { render, staticRenderFns } from "./SidenavHome.vue?vue&type=template&id=3a13d52e"
import script from "./SidenavHome.vue?vue&type=script&lang=js"
export * from "./SidenavHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports